import { authentication } from "@microsoft/teams-js";
import { DYNIZER_TENANT_HEADER_KEY } from "../../models/const";
import { Api as DynizerApi } from "../../services/openapi/dynizer-axios/Api";

export const checkTenant = async (input: string) => {
    let dynizerJwtToken = await authentication.getAuthToken();

    let dynizer = new DynizerApi({
        baseURL: "/dynizer-api",
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
            [DYNIZER_TENANT_HEADER_KEY]: input,
            Authorization: `Bearer ${dynizerJwtToken}`,
        },
    });

    try {
        await dynizer.api.getMyRoles({});
        // 2XX status code
        return true;
    } catch (e: any) {
        // no 2XX status code
        return false;
    }
};
